import { addMinutes, isAfter, isBefore, startOfDay } from 'date-fns';
import { getTestIds } from '../../utils/TestIds';
export const DEFAULT_TIME_STEP_MINUTES = 30;
const FIELD_FORMAT = {
    '12h': 'hh : mm a',
    '24h': 'HH : mm'
};
const SLOT_FORMAT = {
    '12h': 'h:mm a',
    '24h': 'HH:mm'
};
export const fieldFormatFor = (format)=>FIELD_FORMAT[format];
export const slotFormatFor = (format)=>SLOT_FORMAT[format];
export const GetTimePickerTID = (parentTestId)=>getTestIds(parentTestId);
export const timeSlotsFor = (params)=>{
    const { value, referenceDay, timeStep, minTime, maxTime, shouldDisableTime } = params;
    const dayStart = startOfDay(value !== null && value !== void 0 ? value : referenceDay);
    return Array.from({
        length: Math.ceil(24 * 60 / timeStep)
    }, (_, index)=>addMinutes(dayStart, index * timeStep)).filter((slot)=>{
        var _ref;
        return !(minTime != null && isBefore(slot, minTime)) && !(maxTime != null && isAfter(slot, maxTime)) && !((_ref = shouldDisableTime === null || shouldDisableTime === void 0 ? void 0 : shouldDisableTime(slot)) !== null && _ref !== void 0 ? _ref : false);
    });
};
export const steppedByMinutes = (value, minutes)=>addMinutes(value, minutes);
// WHY: MUI ids each editable section `${fieldId}-${sectionType}`; the wrapper span carries no type.
const MINUTES_SECTION_ID_SUFFIX = '-minutes';
export const isMinutesSection = (element)=>(element === null || element === void 0 ? void 0 : element.id.endsWith(MINUTES_SECTION_ID_SUFFIX)) === true;
